import { useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { Checkbox } from "../ui/checkbox";
import { IMAGES } from "../../lib/api";
import { LegalBody, LegalTabs } from "../../pages/Legal";

const ITEMS = [["terms", "Terms of Service"], ["privacy", "Privacy Policy"], ["data", "Data Collection Disclosure"]];

export const AgreeGate = ({ onAgree }) => {
  const [doc, setDoc] = useState("terms");
  const [ok, setOk] = useState({ terms: false, privacy: false, data: false });
  const all = Object.values(ok).every(Boolean);
  return (
    <div data-testid="agree-gate" className="fixed inset-0 z-[60] overflow-y-auto bg-[#050505]">
      <img src={IMAGES.heart} alt="" className="anim-heartbeat pointer-events-none fixed -right-40 top-1/2 h-[720px] w-[720px] -translate-y-1/2 object-cover opacity-25 mix-blend-screen" />
      <div className="rea-scanlines pointer-events-none fixed inset-0 opacity-50" />
      <motion.div initial={{ opacity: 0, y: 24, filter: "blur(10px)" }} animate={{ opacity: 1, y: 0, filter: "blur(0px)" }} transition={{ duration: 0.8 }}
        className="relative mx-auto grid max-w-6xl gap-10 px-5 py-10 sm:px-8 lg:grid-cols-[1fr_1.1fr] lg:py-16">
        <div>
          <img data-testid="rea-lettering-art" src={IMAGES.lettering} alt="R.E.A." className="anim-heartbeat -ml-4 w-full max-w-[460px] mix-blend-screen" style={{ animationDuration: "3.2s", WebkitMaskImage: "radial-gradient(ellipse 70% 62% at 50% 50%, #000 55%, transparent 100%)", maskImage: "radial-gradient(ellipse 70% 62% at 50% 50%, #000 55%, transparent 100%)" }} />
          <p className="rea-label mt-2">Unlovable.Click · Reverse Engineering Analysis</p>
          <h1 className="font-hero mt-6 text-3xl leading-tight sm:text-4xl">Before R.E.A. opens its eyes.</h1>
          <p className="mt-4 max-w-md text-neutral-400">Read and accept the Terms of Service, Privacy Policy and Data Collection Disclosure to enter. No account is created.</p>
          <div className="mt-8 space-y-3">
            {ITEMS.map(([k, l]) => (
              <label key={k} className="flex cursor-pointer items-center gap-3 border border-[#262626] bg-[#0b0b0b] p-3 transition-colors hover:border-red-800">
                <Checkbox data-testid={`agree-${k}-checkbox`} checked={ok[k]} onCheckedChange={(v) => setOk({ ...ok, [k]: !!v })} className="rounded-none border-red-700 data-[state=checked]:bg-red-700" />
                <span className="text-sm">I have read and agree to the <button type="button" onClick={(e) => { e.preventDefault(); setDoc(k); }} className="text-red-400 underline underline-offset-4">{l}</button></span>
              </label>
            ))}
          </div>
          <button data-testid="agree-enter-btn" disabled={!all} onClick={onAgree}
            className="mt-6 flex w-full items-center justify-center gap-2 bg-red-700 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] transition-colors hover:bg-red-600 disabled:cursor-not-allowed disabled:opacity-30">
            <ShieldCheck className="h-4 w-4" /> I Agree & Enter
          </button>
          <button data-testid="agree-all-btn" type="button" onClick={() => setOk({ terms: true, privacy: true, data: true })} className="mt-3 font-mono text-[11px] uppercase tracking-widest text-neutral-500 hover:text-white">Accept all three</button>
        </div>
        <div className="rea-panel rea-brackets flex max-h-[78vh] flex-col">
          <div className="px-4"><LegalTabs active={doc} onPick={setDoc} /></div>
          <div className="overflow-y-auto p-5 rea-scroll"><LegalBody doc={doc} /></div>
        </div>
      </motion.div>
    </div>
  );
};
